var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBreadArrowBalack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19335 4.47343C5.93335 4.73343 5.93335 5.15343 6.19335 5.41343L8.78002 8.0001L6.19335 10.5868C5.93335 10.8468 5.93335 11.2668 6.19335 11.5268C6.45335 11.7868 6.87335 11.7868 7.13335 11.5268L10.1934 8.46676C10.4534 8.20676 10.4534 7.78676 10.1934 7.52676L7.13335 4.46676C6.88002 4.21343 6.45335 4.21343 6.19335 4.47343Z",
    fill: "#333333",
    fillOpacity: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadArrowBalack);
export default __webpack_public_path__ + "static/media/bread_arrow_balack.476240ca30e6e6bc8821a12964aedc07.svg";
export { ForwardRef as ReactComponent };